export default __webpack_public_path__ + "static/media/image-cover.35805b09.jpg";